import { CSSTransition } from 'react-transition-group';
import styles from './Header.module.css';
import * as React from 'react';
export default function Tint(_a) {
    var visible = _a.visible, close = _a.close;
    return (React.createElement(CSSTransition, { in: visible, timeout: 300, unmountOnExit: true, classNames: {
            enter: styles.tintEnter,
            enterActive: styles.tintEnterActive,
            exit: styles.tintExit,
            exitActive: styles.tintExitActive
        } },
        React.createElement("div", { className: styles.tint, onClick: close })));
}
